export const CYBERCHASE_MIGRATION_METRICS: string = "CyberchaseMigrationMetrics";
const PREFIX: string = CYBERCHASE_MIGRATION_METRICS + ".";

export const KEYBOARD_REMAP: string = PREFIX + "KeyboardRemap";
export const CLEAR_TOUCHES: string = PREFIX + "ClearTouches";
export const PLAY_CAPTION: string = PREFIX + "PlayCaption";
export const STOP_CAPTION: string = PREFIX + "StopCaption";

// These topics will either open or close the menu via PubSub
export const OPEN_DEBUG_MENU: string = PREFIX + "OpenDebugMenu";
export const CLOSE_DEBUG_MENU: string = PREFIX + "OpenDebugMenu";

// Callbacks for when the menu is opened or closed
export const ON_DEBUG_MENU_OPENED: string = PREFIX + "OnDebugMenuOpened";
export const ON_DEBUG_MENU_CLOSED: string = PREFIX + "OnDebugMenuClosed";

export const DWELL_BEGIN: string = PREFIX + "DwellBegin";
export const DWELL_CANCELLED: string = PREFIX + "DwellCancelled";
export const DWELL_ACTIVATED: string = PREFIX + "DwellActivated";

export const SETTINGS_CHANGED: string = PREFIX + "SettingsChanged";

export const PAUSE_GAME: string = PREFIX + "PauseGame";
export const UNPAUSE_GAME: string = PREFIX + "UnpauseGame";